/**
 * 新疆热点
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("zhejiangHotSpotsModule", []).
controller("zhejiangHotSpotsCtrl", ["$scope", "$q", "$filter", "trsHttpService", "$state", function($scope, $q, $filter, trsHttpService, $state) {
    initStatus();

    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            threeHot: {
                hotzj: "hot",
            }
        };
    }
}]);